import { render, staticRenderFns } from "./CorrectWords.vue?vue&type=template&id=1dd5495e&scoped=true"
import script from "./CorrectWords.vue?vue&type=script&lang=js"
export * from "./CorrectWords.vue?vue&type=script&lang=js"
import style0 from "./CorrectWords.vue?vue&type=style&index=0&id=1dd5495e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5495e",
  null
  
)

export default component.exports